import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import {
  IAccount,
  UnAssignedAccountCount,
  IUnassignedAccountsResponse,
  IUnassignedAccountsRequest,
  IAccountsAssignmentRequest,
  IUnassignedAccountsAssignmentResponse,
  IUnassignedAccountExportRequest,
  AccountName,
  IRebalResponseObject
} from '@irb/irb-clients/irb-clients.model';
import { UnAssignedAccountService } from '@irb/irb-clients/unassigned/unassigned-account-service';
import { UnassignedGridLayoutService } from '@irb/irb-clients/unassigned/unassigned.grid-layout.service';
import { IEventSubscriber, IEvent, IrbClientsEvents, IrbCreatePortfolioEvents } from '@irb-common/events';
import { Subscription, ReplaySubject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IrbAppEvents } from '@irb/app.events';
import { AppService } from '@irb/app.service';
import { HttpHeaders } from '@angular/common/http';
import { SelectAllGridParent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import { IrbCreatePortfolioService } from '@irb/irb-create-portfolio/irb-create-portfolio.service';
import { MenuItemDef } from 'ag-grid-enterprise';
import { IrbAgGridExportService } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { AnalyticsService } from '@irb-common/analytics/analytics.service';
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import { IrbGridBaseClass } from '@irb-common/components/grid/irb-grid.base';
import { CalltoactionService } from '@irb/irb-common/components/calltoaction/calltoaction.service';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ContextType, CurrentContextService, IContext } from '@charlesschwab/as-ui-core';
import {IFilterModel, IUserDetails} from '@irb/app.model';
import {PreferencesService} from "@irb-common/services/preferences.service";

@Component({ standalone: false,
  selector: 'dux-unassigned',
  templateUrl: './unassigned.component.html',
  styleUrls: ['./unassigned.component.scss'],
  providers: [CurrencyPipe, DatePipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class UnassignedComponent extends IrbGridBaseClass implements OnInit, OnDestroy, IEventSubscriber, SelectAllGridParent {
  params: any;
  rowData: any[];
  gridOptions: any;
  defaultColDef: any;
  components: any;
  rowSelection: any;
  rowModelType: any;
  unAssignedAccounts: any;
  currentDisplayed: number;
  footerContent: any;
  unAssignedAccountCount: UnAssignedAccountCount;
  eventSubscription: Subscription;
  totalRecordsFromServer: number;
  isSelectedAll: boolean;
  uniqueField: string = "id";
  disableActionBtn = true;
  deselectedFromSelectAllRecords: any[] = [];
  headerCheckBoxState: string;
  masterAccountList: string[] = [];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  overlayType: any;
  loadingOverlayComponentParams: any;
  private showClearFilters: boolean = false;
  filterDisplayNamesData: { key: string, mapData: { displayName: string, customData:any, format?: any } }[];
  _filterChipModel: any = {};
  applyFilterOnLanding: any;
  isUiTest = false;
  checkAssignAccountsToOwnPortfolioSub: Subscription;
  hasServerSideDatasource = false;
  selectedRowsMap: Map<string, any> = new Map<string, any>();
  redirectURL: string;
  ENABLE_FLYOUT: boolean = true;
  window: any;
  baseGridApi: any;
  componentName: string = 'unassignedaccounts-v001';
  ENABLE_UNASSIGNED_ACCOUNTS: boolean = false;
  isUnassignActEnabled: boolean = false;
  @ViewChild('accountNumberOverlay', { static: true }) accountNumberOverlay!: TemplateRef<any>;
  row: any;
  userDetails: IUserDetails;
  sacMenuItems = [
    { sanc: 'A_BAL', label: 'Balances' },
    { sanc: 'A_POS', label: 'Positions' }
  ];
  gridFilterPreference = 'unassigned-accounts-filter-pref';
  ENABLE_CUSTOM_HOMEPAGE: boolean = false;
  gridColumnPreference = 'unassigned-accounts-column-pref';

  constructor(
    private readonly unAssignedAccountService: UnAssignedAccountService,
    private cps: IrbCreatePortfolioService,
    public as: AppService,
    private router: Router,
    public ges: IrbAgGridExportService,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private gls: UnassignedGridLayoutService,
    public ats: AnalyticsService,
    private ctas: CalltoactionService,
    private util: UtilityService,
    private cxs: CurrentContextService,
    public pref: PreferencesService
  ) {
    super();
    this.ats.trackUnassignedAccountsEvent();
    this.ENABLE_FLYOUT = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_FLYOUT;
    this.isUnassignActEnabled =  this.as.getItem('IRB_APP_CONFIG')?.featureFlags.isUnassignActEnabled;
    this.ENABLE_CUSTOM_HOMEPAGE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_CUSTOM_HOMEPAGE || false;

    let rowIdIteration = -1;
    this.gridOptions = {
      rowModelType: 'serverSide',
      columnDefs: this.gls.getColumnDefs(this),
      rowSelection: 'multiple',
      context: { componentParent: this, closeToolPanelOnInitialLoad: true },
      getRowId: (params: any) => {
        rowIdIteration++;
        const rowId = 'RowId' + rowIdIteration;
        return params.data.accountNumber + rowId;
      },
      onSortChanged: () => {
        if (this.hasServerSideDatasource) {
          this.setDatasource();
        } else {
          this.refreshGrid();
        }
      }
    };
    this.defaultColDef = { filter: false, menuTabs: [] };
    this.rowSelection = 'multiple';
    this.rowModelType = 'serverSide';
    this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => {
      this.processEvent(s);
    });
    this.setFilterChipsDisplayNames();
    this.redirectURL = this.as.getItem('IRB_APP_CONFIG')?.veoRedirectUrl;
    this.userDetails = this.as.getItem('IRB_APP_CONFIG') as IUserDetails;
    this.window = window;
    this.presetFiltersdataFromSavedFilters();
    this.getGridColumnPreference();
  }

  onGridReady(params: any) {
    this.params = params;
    this.baseGridApi = params.api;
    if (this.hasServerSideDatasource) {
      this.setDatasource();
    } else {
      if (this.applyFilterOnLanding && !this.applyFilterOnLanding.isUpdatRequired)
        this.triggerInitialLoadData();
    }

    this.getUnAssignedAccountCount();
    this.getmasterNumberList();
  }

  setDatasource() {
  this.hasServerSideDatasource = true;
  return {
    getRows: (params: any) => {
      this.overlayType = 'loading';
      this.params.api.showLoadingOverlay();
      const filterKeys: Array<string> = [];

      Object.keys(params.request.filterModel).forEach((key: string) => {
        filterKeys.push(key + "=" + params.request.filterModel[key].filter);
      });

      this._filterChipModel = params.request.filterModel;
      this.saveGridFiltersToLocal(this._filterChipModel);

      this.unAssignedAccountService.getUnAssignedAccounts(
        params,
        filterKeys.join("&"),
        this.ENABLE_UNASSIGNED_ACCOUNTS
      ).pipe(takeUntil(this.destroyed$)).subscribe(data => {
        this.unAssignedAccounts = data.body;
        this.getCurrentCount(data.headers);

        if (this.currentDisplayed === 0) {
          this.showClearFilters = this.unAssignedAccountService._filterCriteria  !== '';
          this.params.api.showNoRowsOverlay();
        } else {
          this.params.api.hideOverlay();
        }

        params.success({ rowData: this.unAssignedAccounts });
      }, () => {
          params.success({ rowData: [] });
          this.showClearFilters = this.unAssignedAccountService._filterCriteria  !== '';
          this.params.api.hideOverlay();
          this.params.api.showNoRowsOverlay();
      });
    }
  };
}

  ngOnInit(): void {
    const cachedToggleStatus = localStorage.getItem('ENABLE_UNASSIGNED_ACCOUNTS');
    this.ENABLE_UNASSIGNED_ACCOUNTS = cachedToggleStatus ? JSON.parse(cachedToggleStatus) : false;
    this.applyFilterOnLanding = this.as.getWindowsState();
    if (this.applyFilterOnLanding && this.applyFilterOnLanding.isUpdatRequired) {
      const noFilter = this.as.getFieldInfo(this.applyFilterOnLanding, 'no-filter');
      if (noFilter) {
        this.applyFilterOnLanding.isUpdatRequired = false;
        this.masterAccountList = [];
        this.saveGridFiltersToLocal(null);
      }
    }
    this.loadingOverlayComponentParams = { parentObject: this };
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.eventSubscription.unsubscribe();
  }

  processEvent(event: IEvent): void {
    switch (event.type) {
      case IrbAppEvents.GRID_REFRESH:
        this.refreshGrid();
        break;
      case IrbAppEvents.GRID_FILTER_RESET:
        this.clearAllFilters();
        break;
      case IrbAppEvents.FIRE_TRACKING_EVENT:
        this.ats.trackUnassignedAccountsEvent();
        break;
    }
  }

  getUnAssignedAccountCount() {
    this.unAssignedAccountService.getUnAssignedAccountCount().subscribe((unAssignedAccountCount: any) => {
      this.unAssignedAccountCount = unAssignedAccountCount;

      if (this.unAssignedAccountCount?.responseData) {
        const totalCount = this.unAssignedAccountCount.responseData.totalCount;
        // const hiddenCount = this.unAssignedAccountCount.responseData.hiddenCount;
        // const visibleCount = totalCount - hiddenCount;
        // const displayedCount = this.ENABLE_UNASSIGNED_ACCOUNTS ? totalCount : visibleCount;

        // this.footerContent = displayedCount + ' of ' + totalCount + ' accounts displayed';
        // this.currentDisplayed = displayedCount;
        if (this.currentDisplayed) {
          this.footerContent = this.currentDisplayed + ' of ' + totalCount + ' accounts displayed';
        }
      }
    });
  }

  getmasterNumberList() {
    this.unAssignedAccountService.getComboDropDownValues('masterAccount').subscribe((res: string[]) => {
      // this.setFilterValues('masterAccount', res);
      this.masterAccountList = res;
      if (this.ENABLE_CUSTOM_HOMEPAGE) {
        let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'masterAccount');
        if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
          filterModel.isUpdatRequired = false;
          this.applyFilterOnLanding.isUpdatRequired = false;
          this.params.api.setColumnFilterModel('masterAccount', {
            values: filterModel.value
          });
          setTimeout(() => {
            this.saveGridFiltersToLocal(null);
            this.params.api.onFilterChanged();
            this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }, 1);
        }
      }
    });
  }

  getUnassignedAccountNumber(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
    if(str.length > 0) {
      this.unAssignedAccountService.paramsForAcctNum = str;
      this.unAssignedAccountService.getUnassignedAccountNumber().subscribe((res: Array<AccountName>) => {
        d.set(res);
      });  
    }
  }

  getUnassignedAccountName(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
    if(str.length > 0) {
      this.unAssignedAccountService.paramsForAcctName = str;
      this.unAssignedAccountService.getUnassignedAccountName().subscribe((res: Array<AccountName>) => {
        const a: AccountName[] = [];

        //group items by account name
        res.forEach((item: AccountName) => {
          let target = a.find((x: AccountName) => x.name === item.name);

            if(target) {
              let b = target.value.toString().split(",");
              b.push(item.value);
              target.value = b.join(",");
            } else {
              a.push(item);
            }
        });

        d.set(a.filter((x: AccountName) => x.name.toLowerCase().includes(str.toLowerCase())));
      });
    }
  }

  // setFilterValues(fieldName: string, setValuesList: string[]) {
  //   switch (fieldName) {
  //     case 'masterAccount':
  //       this.masterAccountList = setValuesList;
  //   }
  //
  //   this.params.api.getColumnFilterInstance(fieldName).then((setFilter: any) => {
  //     if (!this.isUiTest)
  //       setFilter.refreshFilterValues();
  //   });
  // }
private clearSelections() {
  if (this.params && this.params.api) {
    this.params.api.deselectAll();
  }
  this.isSelectedAll = false;
  this.selectedRowsMap = new Map<string, any>();
  this.deselectedFromSelectAllRecords = [];
  this.headerCheckBoxState = 'unchecked';
  this.enableDisableBtns();


  // if (this.params && this.params.api) {
  //   const columns = this.params.api.getAllDisplayedColumns();
  //   if (columns && columns.length > 0) {
  //     this.params.api.refreshHeader();
  //   }
  //
  //   this.params.api.redrawRows();
  // }
}

  refreshGrid() {
    //this.params.api.deselectAll();
    //this.isSelectedAll = false;
    //this.headerCheckBoxState = "unchecked";
    this.clearSelections();
    this.getUnAssignedAccountCount();
    //this.clearAllFilters();
    this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
    this.getmasterNumberList();
  }

  clearAllFilters() {
    this.params.api.setFilterModel(null);
    this.params.api.refreshToolPanel();
    this.clearSelections();
  }

  showImportAccountsToPortfolioDialog() {
    this.ats.trackClickEvent("lc_import");
    this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_ACCOUNTS_TO_PORTFOLIO);
  }

  enableDisableBtns() {
    this.disableActionBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;
  }

  getUnassignedAccountsRequest(): IUnassignedAccountsRequest {
    const r = {
      isSelectAll: this.isSelectedAll,
      showHiddenAccounts: this.ENABLE_UNASSIGNED_ACCOUNTS
    } as IUnassignedAccountsRequest;

    if (this.isSelectedAll) {
      r.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        r.deselectedIds.push(node.id);
      });
    } else {
      r.accountIds = [];
      this.selectedRowsMap.forEach((node: any) => {
        r.accountIds.push(node.id);
      });
    }

    return r;
  }

  getAccountsAssignmentRequest(a: Array<IAccount>, portfolioId?: number): IAccountsAssignmentRequest {
    const r = {
      accountIds: []
    } as IAccountsAssignmentRequest;

    a.forEach(element => {
      r.accountIds.push(element.id || element.accountId);
    });

    if (portfolioId) {
      r.portfolioId = portfolioId;
    }

    return r;
  }

  assignToExistingPortfolio(accountNumber?: number) {
    this.ats.trackClickEvent("md_assignhh");
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    const request = accountNumber ? {
      isSelectAll: false,
      accountIds: [accountNumber],
      showHiddenAccounts: this.ENABLE_UNASSIGNED_ACCOUNTS
    }: this.getUnassignedAccountsRequest();

    this.unAssignedAccountService.getAccountsToBeProcessed(request).subscribe((data: IUnassignedAccountsResponse) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbClientsEvents.SHOW_ASSIGN_ACCOUNTS_TO_PORTFOLIO, {
        portfolioAccounts: data.accountDetails,
        callBack: ((portfolioId?: number, portfolioName?: string) => {
          this.assignToExistingPortfolioCallBack(data, portfolioId, portfolioName)
        })
      });
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  assignToExistingPortfolioCallBack(data: any, portfolioId?: number, portfolioName?: string) {
    if (portfolioId) {
      this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS, {
        portfolioId: portfolioId,
        portfolioName: portfolioName,
        portfolioAccounts: data.accountDetails,
        isAltWorkflow: true,
        finishButtonLabel: "Continue: Assign accounts to portfolio",
        finishButtonCallback: this.completeAssignToExistingPorfolio.bind(this)
      });
    } else {
      this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_CREATE_PORTFOLIO, {
        portfolioName: this.createDefaultPortfolioName(data.accountDetails),
        isAltWorkflow: true,
        callToActionText: "Specify a name for this portfolio.",
        callBack: ((portfolioName: string) => {
          this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS, {
            portfolioName: portfolioName,
            portfolioAccounts: data.accountDetails,
            isAltWorkflow: true,
            finishButtonLabel: "Continue: Assign accounts to portfolio",
            postCreateCallback: this.completeAssignToNewPortfolio.bind(this)
          });
        })
      });
    }
  }

  createDefaultPortfolioName(accountDetails: Array<IAccount>): string {
    if (accountDetails.length === 1 && accountDetails[0].accountName) {
      let accountName = accountDetails[0].accountName.replace(",", "").substring(0,55);
      return accountName + " " + accountDetails[0].accountNumber;
    } else {
      return "";
    }
  }

  completeAssignToExistingPorfolio(portfolioId: number, accountDetails: any, portfolioName: string) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    const r = this.getAccountsAssignmentRequest(accountDetails, portfolioId);

    this.cps.assignAccountsToPortfolio(r).subscribe((d: IUnassignedAccountsAssignmentResponse) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

      if (d.success) {
        let passedToastObject: any = {
          summary: ' Portfolio Updated',
          detail: accountDetails.length + ' account(s) have been assigned to ',
          linkText: portfolioName
        };
        this.assignToPortfolioSuccess(accountDetails, portfolioName, passedToastObject);
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Assign Accounts to Portfolio',
          detail: 'An error occurred processing your request.'
        });
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  completeAssignToNewPortfolio(_portfolioId: number,accountDetails: any, portfolioName: string) {
    this.assignToPortfolioSuccess(accountDetails, portfolioName);
  }

  assignToPortfolioSuccess(accountDetails: any, portfolioName: string, passedToastObject?: any) {
    let toastObject: any = passedToastObject || {
      summary: [accountDetails].length + ' Portfolios Created',
      detail: 'You can stay here to assign more accounts to iRebal portfolios, or you can begin configuring your portfolios by going to the ',
      linkText: 'Portfolio inventory.'
    };
    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      key: 'irb-embedded-link-toast',
      severity: 'success',
      summary: toastObject.summary,
      detail: toastObject.detail,
      sticky: true,
      closable: true,
      life: 5000,
      linkText: toastObject.linkText,
      callBack: (() => {
        this.assignToPortfolioSuccessCallBack(portfolioName);
      })
    });
  }
  assignToPortfolioSuccessCallBack(portfolioName: string) {
    this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
    if (portfolioName) {
      const state: any = {
        isUpdatRequired: true,
        filterModel: {name: 'portfolioName', value: portfolioName, isUpdatRequired: true}
      };
      this.router.navigateByUrl('/clients/portfolios', {state: state});
    } else {
      this.router.navigate(['/clients/portfolios']);
    }
  }

  assignToOwnPortfolio() {
    this.ats.trackClickEvent("md_assignindv");
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.unAssignedAccountService.getAccountsToBeProcessed(this.getUnassignedAccountsRequest()).subscribe((data: IUnassignedAccountsResponse) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS, {
        portfolioAccounts: data.accountDetails,
        isAltWorkflow: true,
        finishButtonLabel: "Create Portfolio",
        finishButtonCallback: (() => {
          const r = this.getAccountsAssignmentRequest(data.accountDetails);

          this.cps.assignAccountsToOwnPortfolio(r).subscribe((response: IRebalResponseObject) => {
            if(response.responseStatus === "EXCEPTION" || typeof response.responseUtilityMap?.statusId === "undefined") {
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Assign Accounts to Portfolio',
                detail: 'An error occurred processing your request.'
              });
            } else {
              this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
              this.checkAssignAccountsToOwnPortfolioStatus(response.responseUtilityMap.statusId, data);
            }
          }); 
        })
      });
    });
  }

  checkAssignAccountsToOwnPortfolioStatus(statusId: string, data: IUnassignedAccountsResponse) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.checkAssignAccountsToOwnPortfolioSub = interval(intervalValue).subscribe(() => {
        this.cps.assignAccountsToOwnPortfolioStatus(statusId).subscribe((response: any) => {
          if(response.responseData.reqStatus.toUpperCase() === "COMPLETED") {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                key: 'irb-embedded-link-toast',
                severity: 'success',
                summary: data.accountDetails.length + ' Portfolios Created',
                detail: 'You can stay here to assign more accounts to iRebal portfolios, or you can begin configuring your portfolios by going to the ',
                sticky: true,
                closable: true,
                linkText: 'Portfolio inventory.',
                callBack: (() => {
                  this.assignToOwnPortfolioCallback(data);
                })
              });

            this.checkAssignAccountsToOwnPortfolioSub.unsubscribe();
              this.refreshGrid();
          } else if(response.responseData.reqStatus.toUpperCase() === "FAILED") {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Assign Accounts to Portfolio',
                detail: 'An error occurred processing your request.'
              });
            this.checkAssignAccountsToOwnPortfolioSub.unsubscribe();
          } else if(response.responseData.reqStatus.toUpperCase() === "IN_PROGRESS") {}
          }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          });
    });
  }

  assignToOwnPortfolioCallback(data: any) {
    this.as.fireEvent(IrbAppEvents.HIDE_TOAST);

    if (data.accountDetails && data.accountDetails.length === 1) {
      const acctName = data.accountDetails[0].accountName;
      let prtflName = acctName.replace(/[^a-zA-Z0-9 .]/g,' ').replace(/\s+/g,' ').trim();
      prtflName += ' ' + data.accountDetails[0].accountNumber;

      const state: any = {
        isUpdatRequired: true,
        filterModel: {name: 'portfolioName', value: prtflName, isUpdatRequired: true}
      };

      this.router.navigateByUrl('/clients/portfolios', {state: state});
    } else {
      this.router.navigate(['/clients/portfolios']);
    }
  }

   exportAccountDetails(accountNumber: any = null) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    let r = {} as IUnassignedAccountExportRequest;

    if (accountNumber) {
      r = {
        isSelectAll: false,
        deselectedIds: [],
        selectedIds: [accountNumber],
        showHiddenAccounts: this.ENABLE_UNASSIGNED_ACCOUNTS
      };
    } else {
      r = {
        isSelectAll: this.isSelectedAll || this.selectedRowsMap.size === 0,
        deselectedIds: [],
        selectedIds: [],
        showHiddenAccounts: this.ENABLE_UNASSIGNED_ACCOUNTS
      };

      if (!r.isSelectAll) {
        this.selectedRowsMap.forEach((item: any) => {
          r.selectedIds.push(item.id);
        });
      }

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        r.deselectedIds.push(node.id);
      });
    }

    this.unAssignedAccountService.exportUnassignedAccountsDetails(r).subscribe((_res) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.ges.showSuccessMessage();
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  getContextMenuItems(): Array<MenuItemDef> {
    return [
      {
        name: "Export CSV",
        action: () => this.exportAccountDetails()
      }
    ];
  }

  private getCurrentCount(headers: HttpHeaders) {
    const contentRange = headers.get('Filter-Count');
    const lengthOfContentRange = contentRange ? contentRange.trim().length : 0;
    const indexOfSlash = contentRange ? contentRange.toString().indexOf('/') : 0;
    this.currentDisplayed = contentRange ? parseInt(contentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;

    if(this.unAssignedAccountCount && this.unAssignedAccountCount.responseData) {
      this.footerContent = this.currentDisplayed + ' of ' + this.unAssignedAccountCount.responseData.totalCount + ' accounts displayed';
    }

    this.totalRecordsFromServer = this.currentDisplayed;
  }

  private setFilterChipsDisplayNames() {
    this.filterDisplayNamesData= [];
    this.filterDisplayNamesData.push({key: 'accountNumber', mapData: {displayName: 'Account', customData:{}}});
    this.filterDisplayNamesData.push({key: 'accountName', mapData: {displayName: 'Name', customData:{}}});
    this.filterDisplayNamesData.push({key: 'marketValue', mapData: {displayName: 'Market Value', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'masterAccount', mapData: {displayName: 'Master Account', customData:{}}});
  }
  onRemoveFilterItem(filterChip: any) {
    let filterField = filterChip[0];
    
    this.params.api.getColumnFilterInstance(filterField).then((f:any) => {
      f.setModel(null);
      this.params.api.onFilterChanged();
    });
  }

  addRemoveFilterToPanel() {
    let customToolPanelColumnDefs: any;
    customToolPanelColumnDefs = [
      {
        headerName: 'Additional Filters',
        children: []
      }
    ];
    return customToolPanelColumnDefs;
  }

  presetFiltersdataFromSavedFilters() {
    let savedFilters = this.getGridFilterPreference();
    if (!savedFilters)
      return;

    if (savedFilters.masterAccount)
      this.masterAccountList = savedFilters.masterAccount.values;
  }
  onToggleAccountsEnabled(event: any): void {
    this.ENABLE_UNASSIGNED_ACCOUNTS = event.checked;
    localStorage.setItem('ENABLE_UNASSIGNED_ACCOUNTS', JSON.stringify(this.ENABLE_UNASSIGNED_ACCOUNTS));

    if (this.params && this.params.api) {
      this.refreshGrid();
    }
  }

  getTemplate(params: any) {
    this.row = params.data;
    return this.accountNumberOverlay;
  }

  hideAccount(account: IAccount) {
    const request = { accountIds: [account.id], isVisible: false };

    this.unAssignedAccountService.updateAccountVisibility(request).subscribe(() => {
      this.getUnAssignedAccountCount();

      if (!this.ENABLE_UNASSIGNED_ACCOUNTS) {
        this.refreshGrid();
      } else {
        account.actIsVisible = false;
        this.baseGridApi.forEachNode((node: any) => {
          if (node.data && node.data.id === account.id) {
            node.setData({ ...node.data, actIsVisible: false });
            this.baseGridApi.redrawRows({ rowNodes: [node] });
          }
        });
        this.baseGridApi.deselectAll();
      }

      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'success',
        summary: 'Success',
        detail: 'Account hidden successfully'
      });

      this.clearSelections();

      this.ctas.remove();
    });
  }

  restoreAccount(account: IAccount) {
    const request = { accountIds: [account.id], isVisible: true };

    this.unAssignedAccountService.updateAccountVisibility(request).subscribe(() => {
      this.getUnAssignedAccountCount();

      if (!this.ENABLE_UNASSIGNED_ACCOUNTS) {
        this.refreshGrid();
      } else {
        account.actIsVisible = true;
        this.baseGridApi.forEachNode((node: any) => {
          if (node.data && node.data.id === account.id) {
            node.setData({ ...node.data, actIsVisible: true });
            this.baseGridApi.redrawRows({ rowNodes: [node] });
          }
        });
        this.baseGridApi.deselectAll();
      }

      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'success',
        summary: 'Success',
        detail: 'Account restored successfully'
      });

      this.clearSelections();

      this.ctas.remove();
    });
  }

  hideSelectedAccounts(): void {
    if (this.isSelectedAll) {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

      const request = this.getUnassignedAccountsRequest();
      this.unAssignedAccountService.getAccountsToBeProcessed(request).subscribe(
        (response: IUnassignedAccountsResponse) => {
          let accountsToProcess = response.accountDetails.filter((acc: any) => acc.actIsVisible !== false);

          const accountIds: number[] = [];
          if (accountsToProcess && accountsToProcess.length > 0) {
            accountsToProcess.forEach((account: any) => {
              accountIds.push(account.id || account.accountId);
            });
          }

          if (accountIds.length === 0) {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.isSelectedAll = false;
            this.selectedRowsMap = new Map<string, any>();
            this.deselectedFromSelectAllRecords = [];
            this.headerCheckBoxState = 'unchecked';
            this.enableDisableBtns();
            return;
          }

          const updateRequest = { accountIds: accountIds, isVisible: false };
          this.unAssignedAccountService.updateAccountVisibility(updateRequest).subscribe(
            () => {
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

              this.isSelectedAll = false;
              this.selectedRowsMap = new Map<string, any>();
              this.deselectedFromSelectAllRecords = [];
              this.headerCheckBoxState = 'unchecked';
              this.enableDisableBtns();

              this.refreshGrid();

              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'success',
                summary: 'Success',
                detail: `${accountIds.length} account(s) hidden`
              });
            },
            () => {
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to hide accounts'
              });
            }
          );
        },
        () => {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to retrieve accounts'
          });
        }
      );
    } else {
      const selectedAccounts: IAccount[] = [];
      this.selectedRowsMap.forEach((account: IAccount) => {
        selectedAccounts.push(account);
      });

      const accountIds: number[] = [];
      selectedAccounts.forEach(account => {
        if (account.actIsVisible !== false) {
          accountIds.push(account.id);
        }
      });

      if (accountIds.length === 0) {
        this.selectedRowsMap = new Map<string, any>();
        this.headerCheckBoxState = 'unchecked';
        this.enableDisableBtns();
        return;
      }

      const request = { accountIds: accountIds, isVisible: false };

      this.unAssignedAccountService.updateAccountVisibility(request).subscribe(() => {
        this.refreshGrid();

        this.clearSelections();

        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Success',
          detail: `${accountIds.length} account(s) hidden`
        });
      });
    }
  }

  restoreSelectedAccounts(): void {
    if (this.isSelectedAll) {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

      const request = this.getUnassignedAccountsRequest();
      this.unAssignedAccountService.getAccountsToBeProcessed(request).subscribe(
        (response: IUnassignedAccountsResponse) => {
          let accountsToProcess = response.accountDetails.filter((acc: any) => acc.actIsVisible === false);

          const accountIds: number[] = [];
          if (accountsToProcess && accountsToProcess.length > 0) {
            accountsToProcess.forEach((account: any) => {
              accountIds.push(account.id || account.accountId);
            });
          }

          if (accountIds.length === 0) {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.isSelectedAll = false;
            this.selectedRowsMap = new Map<string, any>();
            this.deselectedFromSelectAllRecords = [];
            this.headerCheckBoxState = 'unchecked';
            this.enableDisableBtns();
            return;
          }

          const updateRequest = { accountIds: accountIds, isVisible: true };
          this.unAssignedAccountService.updateAccountVisibility(updateRequest).subscribe(
            () => {
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

              this.isSelectedAll = false;
              this.selectedRowsMap = new Map<string, any>();
              this.deselectedFromSelectAllRecords = [];
              this.headerCheckBoxState = 'unchecked';
              this.enableDisableBtns();

              this.refreshGrid();

              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'success',
                summary: 'Success',
                detail: `${accountIds.length} account(s) restored`
              });
            },
            () => {
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to restore accounts'
              });
            }
          );
        },
        () => {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to retrieve accounts'
          });
        }
      );
    } else {
      const selectedAccounts: IAccount[] = [];
      this.selectedRowsMap.forEach((account: IAccount) => {
        selectedAccounts.push(account);
      });

      const accountIds: number[] = [];
      selectedAccounts.forEach(account => {
        if (account.actIsVisible === false) {
          accountIds.push(account.id);
        }
      });

      if (accountIds.length === 0) {
        this.selectedRowsMap = new Map<string, any>();
        this.headerCheckBoxState = 'unchecked';
        this.enableDisableBtns();
        return;
      }

      const request = { accountIds: accountIds, isVisible: true };

      this.unAssignedAccountService.updateAccountVisibility(request).subscribe(() => {
        this.refreshGrid();

        this.clearSelections();

        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Success',
          detail: `${accountIds.length} account(s) restored`
        });
      });
    }
  }

  showHideAction(): boolean {
    if (this.disableActionBtn) return false;

    if (this.isSelectedAll) {
      if (this.unAssignedAccounts && this.unAssignedAccounts.length > 0) {
        const totalCount = this.unAssignedAccountCount?.responseData?.totalCount;
        const hiddenCount = this.unAssignedAccountCount?.responseData?.hiddenCount;
        const visibleCount = totalCount - hiddenCount;
        return visibleCount !== 0;
      }
      return false;
    }

    for (const account of this.selectedRowsMap.values()) {
      if (account.actIsVisible !== false) {
        return true;
      }
    }
    return false;
  }

  showRestoreAction(): boolean {
    if (this.disableActionBtn) return false;

    if (this.isSelectedAll) {
      if (this.unAssignedAccounts && this.unAssignedAccounts.length > 0) {
        const hiddenCount = this.unAssignedAccountCount?.responseData?.hiddenCount;
        if (!this.ENABLE_UNASSIGNED_ACCOUNTS) {
        return false;
      }
        return hiddenCount !== 0;
      }
      return false;
    }

    for (const account of this.selectedRowsMap.values()) {
      if (account.actIsVisible === false) {
        return true;
      }
    }
    return false;
  }

  openSACWithContext(sanc: string) {
    // If no row data, open SAC without context
    if (!this.row) {
      window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
      return;
    }

    const baseURL = this.util.getSacContextGatewayBaseURL();
    const firmId = this.userDetails?.firmId;

    this.cxs.init(baseURL, firmId);

    const currentContext: IContext = {
      contextId: this.row.accountNumber,
      contextType: ContextType.Account,
      name: this.row.accountName || this.row.accountNumber
    };

    this.cxs.save(currentContext)
      .then((ubid: string) => {
        const url = ubid
          ? `${this.redirectURL}/?sanc=${sanc}&ubid=${ubid}`
          : `${this.redirectURL}/?sanc=${sanc}`;
        window.open(url, '_blank');
      })
      .catch(() => {
        // Fallback: open SAC without UBID on error
        window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
      });
  }

  closeMenu() {
    this.ctas.remove();
  }
}

